import { ChangeDetectionStrategy, Component, Input, OnInit, Renderer2 } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../base-component/player-listener.component'
import { ITrack } from '../../../Interface/track'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService } from '../../../services/cart.service'
import { RoutingPathService } from '../../../services/environment.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { TrackInCartService } from '../../../services/track-in-cart.service'

@Component({
  selector: 'bmcore-player-mob',
  templateUrl: './bmcore-player-mob.component.html',
  styleUrls: ['./bmcore-player-mob.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePlayerMobComponent extends PlayerListenerComponentDirective<ITrack> implements OnInit {
  @Input() showBlurredOverlay = false
  @Input() showVerificationIcon = false
  @Input() showFollowBtn = false
  @Input() showLikeBtn = false
  @Input() showFavoriteBtn = false
  @Input() showShareBtn = false

  lg: LgType
  isPlayerMobLg = false
  checkoutPage: string

  constructor(
    public player: PlayerLogic,
    protected cartService: CartService,
    private i18nService: I18nService,
    private renderer: Renderer2,
    public trackInCartService: TrackInCartService,
    private routingPathService: RoutingPathService
  ) {
    super(player, cartService)
    this.checkoutPage = this.routingPathService.getCheckoutUrl()
  }

  ngOnInit() {
    super.ngOnInit()
    this.lg = this.i18nService.getLanguageForPage()
  }

  changePlayerMobView() {
    this.isPlayerMobLg = !this.isPlayerMobLg

    this.renderer[this.isPlayerMobLg ? 'addClass' : 'removeClass'](document.body, 'modal-open')
  }

  closePlayerMobLg() {
    if (this.isPlayerMobLg) {
      this.changePlayerMobView()
    }
  }

  handleClickBuyBtn(event: MouseEvent) {
    if (!this.checkIsTrackInCart(this.player.trackData.id)) {
      this.wantToAddBeat(event, this.player.trackData.id)
    } else {
      this.closePlayerMobLg()
    }
  }

  checkIsTrackInCart(id: number): boolean {
    return this.trackInCartService.checkIsTrackInCart(id)
  }

  wantToAddBeat(event: MouseEvent, beatId: number) {
    event.stopPropagation()
    this.cartService.wantAddBeat(beatId)
  }
}
